import { format as formatDate, subDays } from "date-fns"
import { useDataProvider } from "../../../data_provider/StandardDataProvider"
import DatePicker, { useDateRangeSelectionState } from '../../../date_picker/DateRangePicker'

import { Alert, Avatar, Badge, Button, Card, Center, Checkbox, ColorSwatch, Container, Divider, Grid, Group, Input, JsonInput, Loader, LoadingOverlay, Modal, NumberInput, ScrollArea, Select, Stack, Tabs, Text, Textarea, TextInput, Title, TransferList } from "@mantine/core"
import { useEffect, useState } from "react"
import { EventDetailedView } from "./EventDetailedView"
import { colorSelect } from "./utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faClock, faEdit, faPlus, faPlusCircle, faTrash } from "@fortawesome/free-solid-svg-icons"
import { getEventId, setEventId } from "../../../../utils/UrlLocation"
import { useOutletContext } from "react-router-dom"
import { constructAssetFiltersFromSelections } from "../../../../utils/AssetFilter"
import _ from "lodash"
import { useSetState } from "@mantine/hooks"

export const Content = () => {
        
    const {data, requestId, isDataReady, isLoading, isError, errorMessage, lastRefreshTs, refreshData, autoRefreshEnabled, enableAutoRefresh, disableAutoRefresh} = useDataProvider({
        requestMethod: "GET",
        requestUrl: "/api/dashboard/tron/config",
    })
    

    useEffect(() => {
        refreshData()
    }, [])

    return (
        <Stack style={{overflow: "auto"}}>
            {isLoading && <Center style={{height: "100%"}}><Loader variant="bars" color="red" /></Center>}
            {isError && !isLoading && <Center mt={15}><Alert color="red">{errorMessage}</Alert></Center>}
            {isDataReady && <Temp initialConfig={data} />}
        </Stack>
    )
}

const Temp = ({initialConfig}) => {

    const { assetFrameworkServices } = useOutletContext()

    const [config, setConfig] = useState(_.cloneDeep(initialConfig))
    const [tagGroupConfigModalOpened, setTagGroupConfigModalOpened] = useState(false)
    const [selectedSiteId, setSelectedSiteId] = useState()

    const [eventTemplateTLData, setEventTemplateTLData] = useState(() => {
        const activeEventTemplateIds = config.event_template_ids
        const eventTemplatesActive = []
        const eventTemplatesInactive = []
        assetFrameworkServices.getEventTemplates().forEach(e => {
            if (activeEventTemplateIds.includes(e._id)) eventTemplatesActive.push(e)
            else eventTemplatesInactive.push(e)
        })
        return [
            eventTemplatesInactive.map(x => Object({label: x.code, value: String(x._id)})),
            eventTemplatesActive.map(x => Object({label: x.code, value: String(x._id)}))
        ]
    })
    
    
    
    const {
        data: data,
        requestId: requestId,
        isDataReady: isDataReady,
        isLoading: isLoading,
        isError: isError,
        errorMessage: errorMessage,
        refreshData: refreshData
    } = useDataProvider({
        requestMethod: "POST",
        requestUrl: "/api/dashboard/tron/config/update",
        buildRequestBody: () => Object({
            config: config
        }),
        onSuccessFn: (response, newRequestId) => {
            setConfig(response.data.config)
        }
    })
    

    return (
        <Stack spacing="xl" pb={20} style={{overflow: "auto"}}>
            <Stack spacing="xs">
                <Stack spacing={0}>
                    <Text size="xl" weight={600} underline>Event Templates</Text>
                    <Text size="sm">Select the event templates that will be displayed in the dashboard event list.</Text>
                </Stack>
                <TransferList
                    value={eventTemplateTLData}
                    onChange={(newData) => {
                        setEventTemplateTLData(newData)
                        setConfig((newConfig_) => {
                            const newConfig = _.cloneDeep(newConfig_)
                            const selectedEventTemplateIds = newData[1].map(x => Number(x.value))
                            newConfig.event_template_ids = selectedEventTemplateIds
                            return newConfig
                        })
                    }}
                    titles={["Inactive", "Active"]}
                    listHeight={150}
                    showTransferAll={false}
                    style={{maxWidth: "900px"}}
                />
            </Stack>
            <Stack spacing="sm">
                <Stack spacing={0}>
                    <Text size="xl" weight={600} underline>Trend Data</Text>
                    <Text size="sm" style={{maxWidth: "700px"}}>Select the tag group relevant to each active event template that will define the tags available to trend when an event of that type is selected.</Text>
                </Stack>
                <Stack spacing={2}>
                    <Text size="md" weight={700}>Project</Text>
                    <Select
                        data={assetFrameworkServices.getSites().map(x => Object({label: x.name, value: String(x._id)}))}
                        value={String(selectedSiteId)}
                        onChange={(x) => {
                            setSelectedSiteId(Number(x))
                            //setSelectedTagGroupId(null)
                        }}
                        searchable
                        style={{width: "fit-content"}}
                    />
                </Stack>
            </Stack>

            <TagGroupsConfigurationEditorModal
                key={selectedSiteId}
                isModalOpen={tagGroupConfigModalOpened}
                closeModal={() => setTagGroupConfigModalOpened(false)}
                selectedSiteId={selectedSiteId}
            />

            <Stack style={{width: "fit-content"}}>
                <Group>
                    <Text size="md" weight={700}>Tag Groups Mapping</Text>
                    <Button size="xs" compact onClick={() => setTagGroupConfigModalOpened(true)} style={{width: "fit-content"}}><FontAwesomeIcon icon={faEdit} style={{marginRight: "4px"}} /> Edit Tag Groups</Button>
                </Group>
                <div style={{display: "grid", gap: 15}}>
                    <Text style={{gridRow: 1, gridColumn: 1}}>Event Template</Text>
                    <Text style={{gridRow: 1, gridColumn: 2}}>Tag Group</Text>
                    {eventTemplateTLData[1].map((x, i) => {
                        const tagGroupRefs = config.trend_configs || []
                        const tagGroupRefIdx = tagGroupRefs.findIndex(z => z.event_template_id===Number(x.value) && z.site_id===selectedSiteId)
                        const tagGroupRef = tagGroupRefs[tagGroupRefIdx] || {}
                        const tagGroupId = tagGroupRef.tag_group_id
                        
                        return (
                            <>
                                <div style={{gridRow: i+2, gridColumn: 1, alignSelf: "center"}}>
                                    <Text weight={500}>{x.label}</Text>
                                </div>
                                <div style={{gridRow: i+2, gridColumn: 2, alignSelf: "center"}}>
                                    <Select
                                        data={selectedSiteId ? assetFrameworkServices.getTagGroups(selectedSiteId).map(x => Object({label: x.name, value: String(x._id)})) : []}
                                        value={tagGroupId ? String(tagGroupId) : null}
                                        onChange={(v) => setConfig((newConfig_) => {
                                            const newConfig = _.cloneDeep(newConfig_)
                                            if (!newConfig.trend_configs) newConfig.trend_configs = []
                                            if (tagGroupRefIdx===-1) {
                                                newConfig.trend_configs.push({
                                                    event_template_id: Number(x.value),
                                                    site_id: selectedSiteId,
                                                    tag_group_id: Number(v)
                                                })
                                            }
                                            else {
                                                if (!v) newConfig.trend_configs.splice(tagGroupRefIdx, 1) // If value is cleared
                                                else newConfig.trend_configs[tagGroupRefIdx].tag_group_id = Number(v)
                                            }
                                            return newConfig
                                        })}
                                        nothingFound={selectedSiteId ? "No tag groups" : "Select a site first"}
                                        placeholder="Select a tag group"
                                        clearable
                                        //style={{width: "fit-content"}}
                                    />
                                </div>
                            </>
                        )
                    })}
                </div>
            </Stack>
            <Divider></Divider>
            {!isLoading && isError &&
                <Alert color="red" style={{flexShrink: 0}}>{errorMessage}</Alert>
            }
            {!isLoading && isDataReady &&
                <Alert color="green" style={{flexShrink: 0}}>Success</Alert>
            }
            <Stack style={{display: "inline-block"}}>
                <Button
                    color="green"
                    onClick={refreshData}
                    disabled={isLoading}
                >
                    {isLoading && <Loader size="sm" mr={6} />}
                    Update configuration
                </Button>
            </Stack>
        </Stack>
    )
}

const TagGroupsConfigurationEditorModal = ({isModalOpen, closeModal, selectedSiteId}) => {

    const { assetFrameworkServices } = useOutletContext()
    
    const [newTagGroup, setNewTagGroup] = useState(null)
    const [selectedTagGroupId, setSelectedTagGroupId] = useState()
    
    
    const selectedTagGroup = assetFrameworkServices.getTagGroup(selectedTagGroupId)
    const selectedSiteName = assetFrameworkServices.getSites(selectedSiteId).name
    const siteTagGroups = selectedSiteId ? assetFrameworkServices.getTagGroups(selectedSiteId) : []
    const isCreating = Boolean(newTagGroup)
    
    const onSaveTagGroupSuccess = (createdTagGroup) => {
        if (isCreating) {
            assetFrameworkServices.addTagGroup(createdTagGroup)
            setNewTagGroup(null)
            setSelectedTagGroupId(createdTagGroup._id)
        }
        else assetFrameworkServices.updateTagGroup(createdTagGroup)
    }
    
    const deleteTagGroup = () => {
        if (isCreating) setNewTagGroup(null)
        else {
            assetFrameworkServices.deleteTagGroup(selectedTagGroup)
            setSelectedTagGroupId(null)
        }
    }


    return (
        <Modal
            opened={isModalOpen}
            onClose={closeModal}
            title={
                <Text size="lg" weight={500}>
                    {selectedSiteName} Tag Groups
                </Text>
            }
            size={1000}
        >
            <Stack>
                <Divider />
                <Group align="flex-end">
                    <Select
                        data={siteTagGroups.map(x => Object({label: x.name, value: String(x._id)}))}
                        value={String(selectedTagGroupId)}
                        onChange={(v) => {
                            setSelectedTagGroupId(Number(v))
                            setNewTagGroup(null)
                        }}
                        label="Tag Group"
                        nothingFound={selectedSiteId ? "No tag groups" : "Select a site"}
                        placeholder="Select a tag group"
                        style={{width: "fit-content"}}
                    />
                    <Button
                        color="green"
                        onClick={() => {
                            setNewTagGroup(buildNewTagGroupSchema(selectedSiteId))
                            setSelectedTagGroupId(null)
                        }}
                    >
                        <FontAwesomeIcon icon={faPlusCircle} style={{marginRight: "4px"}} />
                        New Tag Group
                    </Button>
                </Group>
                {(selectedTagGroup || newTagGroup) &&
                    <TagGroup
                        key={selectedTagGroupId}
                        initialTagGroup={newTagGroup || selectedTagGroup}
                        selectedSiteId={selectedSiteId}
                        isCreate={isCreating}
                        onSaveTagGroupSuccess={onSaveTagGroupSuccess}
                        deleteTagGroup={deleteTagGroup}
                    />
                }
            </Stack>
        </Modal>
    )
}

const buildNewTagGroupSchema = (selectedSiteId) => {
    return {
        site_id: selectedSiteId,
        id: null,
        name: null,
        tags: []
    }
}

const TagGroup = ({initialTagGroup, selectedSiteId, isCreate, onSaveTagGroupSuccess, deleteTagGroup}) => {

    const { assetFrameworkServices } = useOutletContext()

    const [tagGroup, setTagGroup] = useState(_.cloneDeep(initialTagGroup))

    const endpoint = isCreate ? "/api/asset_framework/tag_group/create" : "/api/asset_framework/tag_group/update"
    const {
        data: data,
        requestId: requestId,
        isDataReady: isDataReady,
        isLoading: isLoading,
        isError: isError,
        errorMessage: errorMessage,
        refreshData: refreshData
    } = useDataProvider({
        requestMethod: "POST",
        requestUrl: endpoint,
        buildRequestBody: () => Object({
            tagGroupSchema: tagGroup
        }),
        onSuccessFn: (response, newRequestId) => onSaveTagGroupSuccess(response.data.tagGroup)
    })
    
    const {
        data: dataDel,
        requestId: requestIdDel,
        isDataReady: isDataReadyDel,
        isLoading: isLoadingDel,
        isError: isErrorDel,
        errorMessage: errorMessageDel,
        refreshData: refreshDataDel
    } = useDataProvider({
        requestMethod: "POST",
        requestUrl: "/api/asset_framework/tag_group/delete",
        buildRequestBody: () => Object({
            tagGroupId: tagGroup._id
        }),
        onSuccessFn: (response, newRequestId) => deleteTagGroup(tagGroup)
    })

    
    const updateTagGroup = (fn) => {
        setTagGroup((tagGroup_) => {
            const newTagGroup_ = _.cloneDeep(tagGroup_)
            fn(newTagGroup_)
            return newTagGroup_
        })
    }

    const isEitherLoading = isLoading || isLoadingDel
    const showErrorAlert = (!isEitherLoading && (isError || isErrorDel))
    const showSuccessAlert = (!isEitherLoading && (isDataReady || isDataReadyDel)) && !showErrorAlert


    return (
        <Card withBorder style={{display: "flex", flexDirection: "column", gap: 15}}>
            <LoadingOverlay visible={isLoading || isLoadingDel} />
            <Card.Section>
                <Text weight={500} p={10} style={{textAlign: "center"}}>{isCreate ? "New" : tagGroup.name} Tag Group</Text>
                <Divider />
            </Card.Section>
            {showSuccessAlert && <Alert color="green">Success</Alert>}
            {showErrorAlert && <Alert color="red">{errorMessage || errorMessageDel}</Alert>}
            <Group>
                <TextInput
                    value={tagGroup.id}
                    onChange={(e) => {
                        const value = e.currentTarget.value
                        updateTagGroup((newTagGroup) => newTagGroup.id = value)
                    }}
                    label="Code"
                />
                <TextInput
                    value={tagGroup.name}
                    onChange={(e) => {
                        const value = e.currentTarget.value
                        updateTagGroup((newTagGroup) => newTagGroup.name = value)
                    }}
                    label="Name"
                />
            </Group>
            <Text weight={500}>Tags</Text>
            <div style={{display: "grid", gap: 15}}>
                <Text style={{gridRow: 1, gridColumn: 2}}>Device</Text>
                <Text style={{gridRow: 1, gridColumn: 3}}>Tag ID</Text>
                <Text style={{gridRow: 1, gridColumn: 4}}>Tag Res Type</Text>
                <Text style={{gridRow: 1, gridColumn: 5}}>Initial Visibility</Text>
                {tagGroup.tags.map((config, i) => {

                    const selectedDevice = assetFrameworkServices.getDevice(config.device_id)
                    const selectedDeviceTagTemplateIds = selectedDevice?.tags ? selectedDevice.tags.map(x => x.template_id) : []


                    const deviceOptions = _.sortBy(assetFrameworkServices.getDevices(selectedSiteId).map(x => Object({label: x.full_path, value: String(x._id)})), "label")
                    const tagOptions = _.sortBy(assetFrameworkServices.getTags().filter(tag => selectedDeviceTagTemplateIds.includes(tag._id)).map(x => Object({label: x.name, value: String(x._id)})), "label")

                    return (
                        <>
                            <Group style={{gridRow: i+2, gridColumn: 1, alignSelf: "center"}}>
                                <FontAwesomeIcon
                                    icon={faTrash}
                                    color="red"
                                    onClick={() => {
                                        updateTagGroup((newTagGroup) => {
                                            newTagGroup.tags.splice(i, 1)
                                        })
                                    }}
                                />
                                <Text>{i+1}</Text>
                            </Group>
                            <div style={{gridRow: i+2, gridColumn: 2}}>
                                <Select
                                    data={deviceOptions}
                                    value={String(config.device_id)}
                                    onChange={(device_id) => {
                                        updateTagGroup((newTagGroup) => {
                                            newTagGroup.tags[i].device_id = Number(device_id)
                                            newTagGroup.tags[i].tag_id = null
                                        })
                                    }}
                                    searchable
                                />
                            </div>
                            <div style={{gridRow: i+2, gridColumn: 3}}>
                                <Select
                                    data={tagOptions}
                                    value={String(config.tag_id)}
                                    onChange={(tag_id) => updateTagGroup((newTagGroup) => newTagGroup.tags[i].tag_id = Number(tag_id))}
                                    searchable
                                    nothingFound={config.device_id ? "Device has no tags" : "Select a device"}
                                />
                            </div>
                            <div style={{gridRow: i+2, gridColumn: 4}}>
                                <Select
                                    data={[{label: "Interval", value: "interval"}, {label: "Raw", value: "raw"}]}
                                    value={config.type}
                                    onChange={(value) => updateTagGroup((newTagGroup) => newTagGroup.tags[i].type = value)}
                                />
                            </div>
                            <div style={{gridRow: i+2, gridColumn: 5, alignSelf: "center"}}>
                                <Checkbox
                                    checked={config.config.visible}
                                    onChange={(e) => {
                                        const value = e.currentTarget.checked
                                        updateTagGroup((newTagGroup) => newTagGroup.tags[i].config.visible = value)
                                    }}
                                />
                            </div>
                        </>
                    )
                })}
            </div>
            <Button
                onClick={() => {
                    const newTagGroup = _.cloneDeep(tagGroup)
                    newTagGroup.tags.push({
                        _id: null,
                        device_id: null,
                        tag_id: null,
                        type: null,
                        config: {
                            visible: true
                        }
                    })
                    setTagGroup(newTagGroup)
                }}
                color="green"
                px="7%"
                m="0 auto"
            >
                <Group spacing="xs">
                    <FontAwesomeIcon icon={faPlusCircle} />
                    Add tag
                </Group>
            </Button>
            <Card.Section>
                <Divider />
                <Group position="apart" p={10}>
                    <Button color="red" onClick={isCreate ? deleteTagGroup : refreshDataDel}>{isCreate ? "Cancel" : "Delete"}</Button>
                    <Button onClick={refreshData}>{isCreate ? "Create" : "Save"}</Button>
                </Group>

            </Card.Section>
        </Card>
    )
}